// Constructor
function DataFilters(app) {
	this.app = app;
	this.modesData = false;
	this.timeouts = {};
	this.introPlayed = false;
	this.init();
}

DataFilters.prototype.init = function (gameName) {
	$.ajax({
		url: "datafilters.html",
		dataType: 'html',
		cache: false,
		complete: $.proxy(function (data, textStatus) {
			$("#game").html(data.responseText);
			this.app.initSVG();

			$.ajax({
				url: "datafilters-modes.json",
				dataType: 'json',
				cache: false,
				complete: $.proxy(function (data) {
					this.modesData = JSON.parse(data.responseText);
					this.createDOM();
					this.initSliders();
					this.initModeTriggers();
				}, this)
			});

		}, this)
	});

};

DataFilters.prototype.closeHelp = function (noIntro) {

	var noIntro = noIntro || false;

	$("#help").addClass("hide");

	setTimeout($.proxy(function (noIntro) {
		$("#help").addClass("hidden");

		// Trigger intro
		if (this.introPlayed == false && noIntro == false) {
			this.playIntroSequence();
			this.introPlayed = true;
		}

	}, this, noIntro), 700);
}

DataFilters.prototype.showHelp = function (callback) {

	$("#help").removeClass("hidden");

	setTimeout(function () {
		$("#help").removeClass("hide");
	}, 50)
}

DataFilters.prototype.createDOM = function () {

	for (var i = 0; i < this.modesData["modes"].length; i++) {
		var mode = this.modesData["modes"][i];
		var el = $("#left-content .mode-" + (i + 1));
		var menuEl = $("#right-content .mode-" + (i + 1));

		if (el.length == 0) {
			el = $("#left-content .mode-1").clone();
			el.removeClass("mode-1").addClass("hide mode-" + (i + 1));
			$("#left-content").append(el);
			menuEl = $("#right-content .mode-1").clone();
			menuEl.removeClass("mode-1").addClass("hide mode-" + (i + 1));
			menuEl.attr("data-mode", (i + 1));

			$("#right-content .wrapper").append(menuEl);
		}

		// Set left content
		el.find(".mode-title .fr").text(mode["mode_title_fr"]);
		el.find(".mode-title .en").text(mode["mode_title_en"]);
		el.find(".mode-description .fr").text(mode["mode_description_fr"]);
		el.find(".mode-description .en").text(mode["mode_description_en"]);

		// Set satellite view image
		el.find(".satellite-view").attr("src", mode["stallite_view_image"]);

		// Set right content (menu)
		menuEl.find(".title .fr").text(mode["mode_title_fr"]);
		menuEl.find(".title .en").text(mode["mode_title_en"]);

		// Set left content - subcontent (slides)
		for (var j = 0; j < 4; j++) {

			var submode = mode["submodes"][j];
			var elTrigger = $(".slide-triggers a", el).eq(j);
			var slide = el.find(".slides .slide").eq(j);

			if (j < mode["submodes"].length) {

				if (elTrigger.length == 0) {
					elTrigger = $(".slide-triggers a", el).first().clone();
					elTrigger.removeClass("current");
					$(".slide-triggers", el).append(elTrigger);
				}

				if (slide.length == 0) {
					slide = el.find(".slides .slide").first().clone();
					slide.removeClass("current");
					$(".slides", el).append(slide);
				}

				// Right item
				elTrigger.find("span.fr").text(submode["title_fr"]);
				elTrigger.find("span.en").text(submode["title_en"]);
				elTrigger.attr("data-trigger", submode["name"]);

				// Left item slide
				slide.attr("data-trigger", submode["name"]);
				slide.find("img.main-image").attr("src", submode["image"]);
				slide.find(".tiles .tile").css("background-image", "url('" + submode["image"] + "')");

				// Copyrights
				slide.find(".copyrights .fr").text(submode["copyrights_fr"]);
				slide.find(".copyrights .en").text(submode["copyrights_en"]);

				// Left mode
				slide.find(".toggle-button, .legend").toggleClass("left", (mode["legend_position"] == "left"))

				// Left item legend
				var legend = slide.find(".legend");
				if (typeof submode["legend"] != "undefined") {
					legend.find(".top .legend-left .fr").text(submode["legend"]["left"]["text_fr"]);
					legend.find(".top .legend-left .en").text(submode["legend"]["left"]["text_en"]);
					legend.find(".top .legend-right .fr").text(submode["legend"]["right"]["text_fr"]);
					legend.find(".top .legend-right .en").text(submode["legend"]["right"]["text_en"]);

					legend.find(".legend-title .fr").text(submode["title_fr"]);
					legend.find(".legend-title .en").text(submode["title_en"]);

					legend.find(".legend-description .fr").text(submode["description_fr"]);
					legend.find(".legend-description .en").text(submode["description_en"]);

					if (submode["description_fr"] == "" && submode["description_en"] == "") {
						legend.css("background", "transparent")
						legend.find(".legend-title").hide();
					}

					if (submode["legend"]["gradient"] != "") {
						legend.find(".top").css("background", "-webkit-linear-gradient(left, " + submode["legend"]["gradient"] + ")");
					} else {
						legend.find(".top").css("background", "");
					}

				} else {
					// Remove useless items
					legend.remove();
				}

			} else {
				// Remove useless items
				elTrigger.remove();
				slide.remove();
			}
		}
	}

};

DataFilters.prototype.initModeTriggers = function () {
	$(".section-right .mode-button").on("click", $.proxy(this.changeMode, this));
	$(".toggle-button").on("click", $.proxy(function (e) {
		var isOn = $(".slide.current").hasClass("tiles-shown");
		$(".slide.current").toggleClass("tiles-shown", !isOn);
		$(e.currentTarget).toggleClass("eye", isOn);
		$(".base-map").toggleClass("hide-copyrights", !isOn);
	}, this));
};

DataFilters.prototype.goIntro = function () {

	$(".intro-1, .intro-2, .intro-3, .intro-4").addClass("in").removeClass("out");
	$(".intro").removeClass("hide");
	$(".intro .copyrights").removeClass("hide");
	$("#right-content").addClass("disabled");

	// Show content by triggering first menu item
	this.timeouts["showHelp"] = setTimeout($.proxy(function () {
		this.showHelp();
	}, this), 1000);

};

DataFilters.prototype.playIntroSequence = function () {

	// Animate each slide (1-4)
	for (var i = 0; i <= 4; i++) {

		// reset
		this.timeouts["intro" + i + "1"] = setTimeout($.proxy(function (i) {
			$(".intro-" + (i + 1)).removeClass("in");


			if (i == 4) {
				$(".mode-button.mode-1").trigger("click");
				$("#right-content").removeClass("disabled");
				$(".intro .copyrights").addClass("hide");
			}

		}, this, i), 500 + (i * 2200));

		// fade in
		this.timeouts["intro" + i + "2"] = setTimeout($.proxy(function (i) {
			$(".intro-" + (i + 1)).addClass("out");
		}, this, i), 1400 + (i * 2200));

		//fade out
		this.timeouts["intro" + i + "3"] = setTimeout($.proxy(function (i) {

			if (i != 4) {
				$(".intro-" + (i + 1)).removeClass("out");
			} else {
				// $(".mode-button.mode-1").trigger("click");
				// $("#right-content").removeClass("disabled");
				// $(".intro .copyrights").addClass("hide");
			}

		}, this, i), 3400 + (i * 2200));
	}
}


DataFilters.prototype.changeMode = function (e) {
	e.preventDefault();

	var btn = e.currentTarget;
	var mode = $(btn).data("mode");

	if ($(btn).hasClass("current")) {
		console.log("exit")
		return;
	}

	$("#slides-viewer .specific.current .slides").addClass("hide");


	// Show callback
	$("#slides-viewer .specific").one(window.transitionEnd, $.proxy(function () {

		// Show
		this.resetSliders();
		$("#slides-viewer .specific.mode-" + mode).removeClass("hide").addClass("current");

		// Hide satellite view
		$("#slides-viewer .specific.mode-" + mode + " .satellite-view").addClass("hide");

		this.timeouts["changeMode1"] = setTimeout(function () {
			$("#slides-viewer .specific.mode-" + mode + " .slides").removeClass("hide");
			$("#slides-viewer .specific.mode-" + mode + " .slides").find(".slide").first().addClass("current tiles-shown")
			$("#slides-viewer .specific.mode-" + mode + " .satellite-view").removeClass("hide");
		}, 500);

	}, this)).addClass("hide").removeClass("current");

	// This is waht trigger previous callback
	if ($("#slides-viewer .specific.current .slides .slide.current").length == 0) {
		$("#slides-viewer .specific").trigger(window.transitionEnd);
	} else {
		$("#slides-viewer .specific.current .slides .slide").removeClass("current");
	}

	$(".section-right .mode-button").removeClass("current");
	$(btn).addClass("current");
};

DataFilters.prototype.initSliders = function () {
	console.log("init sliders");
	$(".slides-container .slide-triggers a").on("click", $.proxy(this.changeSlide, this));

};

DataFilters.prototype.resetSliders = function () {
	$(".slides-container").each(function (i, e) {
		$(this).find(".slide-triggers a").removeClass("current").first().addClass("current");
		$(this).find(".slide").removeClass("current tiles-shown");
		$(this).find(".toggle-button").removeClass("eye");
		$(".base-map").addClass("hide-copyrights");
	});
};

DataFilters.prototype.changeSlide = function (e) {
	e.preventDefault();

	var btn = e.currentTarget;

	if ($(btn).hasClass("current")) {
		return;
	}

	var trigger = $(btn).data("trigger");
	var $slider = $(btn).parents(".slides-container");

	$slider.find(".slide, .slide-triggers a").removeClass("current tiles-shown");
	$slider.find('.slide[data-trigger="' + trigger + '"]').addClass("current tiles-shown");
	$slider.find(".toggle-button").removeClass("eye");
	$(".base-map").addClass("hide-copyrights");
	$(btn).addClass("current");
};

DataFilters.prototype.start = function () {

	// Animate title bar
	$("#title-screen").fadeOut("normal", function () {
		$("#slides-viewer").fadeIn("normal");
	});

	// Launch intro
	this.goIntro();
};

DataFilters.prototype.reset = function () {

	// Close help with no intro
	this.closeHelp(true);

	// Reset intro played var
	this.introPlayed = false;

	// Clear saved timeouts
	var timersKeys = Object.keys(app.game.timeouts);
	for (var i = 0; i < timersKeys.length; i++) {
		if (typeof this.timeouts[timersKeys[i]] != "undefined" && this.timeouts[timersKeys[i]] != false) {
			clearTimeout(this.timeouts[timersKeys[i]]);
			this.timeouts[timersKeys[i]] = false;
		}
	}

	// Reset intro slides
	for (var i = 0; i < 4; i++) {
		$(".intro-1, .intro-2, .intro-3, .intro-4").addClass("in").removeClass("out");
	}

	$("#slides-viewer .specific").addClass("hide").removeClass("current");
	$("#slides-viewer .specific .slides").addClass("hide").removeClass("current");
	$(".section-right .mode-button").removeClass("current");
	$("intro").addClass("hide");

	console.log("reset")
	console.log($("#slides-viewer .specific"))

	$("#slides-viewer").fadeOut("normal", function () {
		$("#title-screen").fadeIn("normal");
	});

};

// Expose DataFilters
window.DataFilters = DataFilters;
